import { render, staticRenderFns } from "./ModalBorder.vue?vue&type=template&id=09a80357&scoped=true&lang=pug&"
import script from "./ModalBorder.vue?vue&type=script&lang=ts&"
export * from "./ModalBorder.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBorder.vue?vue&type=style&index=0&id=09a80357&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a80357",
  null
  
)

export default component.exports